export class Partner {
    PartnerCode: string;
    PartnerName: string;
    Address: string;
    City: string;
    ZipCode: string;
    VatNumber: string;
    ShortAdministrative: string;
    AccreditationNumber: string;

    static mapFromJSON(json): Partner {
        const p = new Partner;

        p.PartnerCode = json['partnerCode'];
        p.PartnerName = json['partnerName'];
        p.Address = json['address'];
        p.City = json['city'];
        p.ZipCode = json['zipCode'];
        p.VatNumber = json['vatNumber'];
        p.ShortAdministrative = json['shortAdministrative'];
        p.AccreditationNumber = json['accreditationNumber'];

        return p;
    }
}